<template>
    <div class="row" style="width: 100%;max-width: 100%; display: flex;" :key="renderKey" v-if="renderKey != 0">
        <div class="col-md-12" :key="renderKey">
            <apexchart
                v-if="chartOptions && series"
                :key="renderKey"
                type="line"
                height="500"
                :options="chartOptions"
                :series="series"
            />
        </div>
    </div>

</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {Money} from './../../../services/Money.js';

export default {
    name: "SummaryChart",
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        config: {
            type: Object,
        },
        buySummary:{
            type:Object,
        },
        sellSummary:{
            type:Object
        },
        mode:{
            type:String,
            default:"standard"
        }
    },
    data: function () {
        return {
            money: new Money(),
            renderKey: 0
        }
    },
    mounted() {
        setTimeout(() => { this.renderKey = 100 }, 500)
    },
    computed: {
        getYAxis() {
            const self = this;
            let axis = [
                {
                    seriesName: this.__("sell_documents"),
                    axisTicks: {
                        show: true
                    },
                    axisBorder: {
                        show: true,
                    },
                    title: {
                        text: this.__("value")
                    },
                    forceNiceScale: true,
                    labels: {
                        formatter: function (val) {
                            return self.money.localizeWithInt(val);
                        },
                    },
                },
                {
                    seriesName: this.__("sell_documents"),
                    show: false
                },
            ];
            if(this.config.include_sell_document_count == 1){
                axis.push({
                    opposite: true,
                    seriesName: this.__('sell_documents_count'),
                    axisTicks: {
                        show: true
                    },
                    axisBorder: {
                        show: true,
                    },
                    forceNiceScale: true,
                    title: {
                        text: this.__('sell_documents_count')
                    },
                    labels: {
                        formatter: function (val) {
                            return val.toFixed(); // Konwersja na liczbę całkowitą
                        },
                    },

                })
            }
            return axis
        },
        chartOptions() {
            const yAxis = this.getYAxis;
            const self  = this;
            const yRange = this.getYRange();
            return {
                chart: {
                    stacked: false,
                    toolbar: {
                        show: this.mode == 'standard', // Dodaj warunek na podstawie twojej zmiennej mode
                    },
                    width:"100%",
                    defaultLocale: 'pl',
                    locales: [{
                        name: 'pl',
                        options: {
                            toolbar: {
                                exportToSVG:$.i18n._('chart_export_SVG'),
                                exportToPNG:$.i18n._('chart_export_PNG') ,
                                exportToCSV:$.i18n._('chart_export_CSV'),
                                zoomIn:$.i18n._('chart_zoom_in'),
                                zoomOut:$.i18n._('chart_zoom_out'),
                                pan:$.i18n._('chart_pan'),
                                reset:$.i18n._('chart_reset'),
                            }
                        }
                    }],
                },
                xaxis: {
                    categories: this.getCategories(this.sellSummary)

                },
                fill: {
                    type: "solid",  // Dodaj tę linię
                },
                yaxis:  yAxis,
                yaxis2: {
                    opposite: true,
                    title: {
                        text: "Ilość dokumentów (druga oś Y)",
                        style: {
                            color: "#FEB019",
                        },
                    },
                    labels: {
                        formatter: function (val) {
                            return val.toFixed(); // Konwersja na liczbę całkowitą
                        },
                    },
                    forceNiceScale: true,
                },
                colors: this.getColors,
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return self.money.localize(y);
                            }
                            return y;
                        },
                    },
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none' // Wyłącza przezroczystość na hover
                        }
                    }
                },
            };
        },
        firstSeriesVisible(){
            return this.config.sell_value_in_base_currency_gross || this.config.sell_value_in_base_currency_net;
        },
        secondSeriesVisible(){
            return this.config.buy_value_in_base_currency_net || this.config.buy_value_in_base_currency_gross || this.config.buy_value_in_base_currency_net_and_vat;
        },
        thirdSeriesVisible(){
            return this.config.include_sell_document_count == 1;
        },
        getColors(){
            if(this.firstSeriesVisible && this.secondSeriesVisible && this.thirdSeriesVisible){
                return ['#006000', '#FF0000', '#000000']
            }
            if(this.firstSeriesVisible && this.secondSeriesVisible){
                return ['#006000', '#FF0000']
            }
            if(this.firstSeriesVisible && this.thirdSeriesVisible){
                return ['#006000', '#000000']
            }
            if(this.secondSeriesVisible && this.thirdSeriesVisible){
                return ['#FF0000', '#000000']
            }
            if(this.firstSeriesVisible){
                return ['#006000']
            }
            if(this.secondSeriesVisible){
                return ['#FF0000']
            }
            if(this.thirdSeriesVisible){
                return ['#000000']
            }
        },
        series() {
            let data = [];
            const sellKeys = this.getCategories(this.sellSummary);
            if(this.config.sell_value_in_base_currency_net || this.config.sell_value_in_base_currency_gross){
                data.push({
                    name: this.__("sell_documents"),
                    type: 'column',
                    data: this.getSellSeries(),
                    fill: {
                        type: "gradient",
                        gradient: {
                            shade: "dark", // Ustawienie odcienia koloru
                            type: "vertical", // Kierunek gradientu
                            shadeIntensity: 0.5, // Intensywność odcienia
                            gradientToColors: ['#006000'], // Kolor do którego ma przechodzić gradient
                            inverseColors: false,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100]
                        }
                    }
                },)
            }
            if(this.config.buy_value_in_base_currency_net || this.config.buy_value_in_base_currency_gross || this.config.buy_value_in_base_currency_net_and_vat){
                data.push(  {
                    name: this.__("buy_documents"),
                    type: 'column',
                    data: this.getBuySeries()
                },)
            }


            if(this.config.include_sell_document_count == 1){
                data.push({
                    name: this.__('sell_documents_count'),
                    type: 'line',
                    data: sellKeys.map((key) => this.sellSummary[key].document_sum)
                },)
            }
            return data
        },
    },
    methods:{
        getYRange() {
            if (this.config.y_axis_range === "positive") {
                // Dla wartości dodatnich
                return {
                    min: 0,
                };
            } else {
                // Dla wartości ujemnych i dodatnich
                return {};
            }
        },
        getCategories(obj){
            if(this.config.period == 12){
                return Object.keys(obj).slice(0,12).reverse()
            }
            else{
                return Object.keys(obj).reverse()
            }
        },
        getSellSeries(){
            const sellKeys = this.getCategories(this.sellSummary);
            if(this.config.sell_value_in_base_currency_net){
                if(this.config.include_correction == "1"){
                    return sellKeys.map((key) => this.sellSummary[key].net_amount_corrected_sum)
                }
                else{
                    return sellKeys.map((key) => this.sellSummary[key].net_amount_sum)
                }
            }
            if(this.config.sell_value_in_base_currency_gross){
                if(this.config.include_correction == "1"){
                    return sellKeys.map((key) => this.sellSummary[key].gross_amount_corrected_sum)
                }
                else{
                    return sellKeys.map((key) => this.sellSummary[key].gross_amount_sum)
                }
            }
        },
        getBuySeries(){
            const buyKeys = this.getCategories(this.buySummary)
            if(this.config.buy_value_in_base_currency_net){
                if(this.config.include_correction == "1"){
                    return buyKeys.map((key) => this.buySummary[key].net_amount_corrected_sum)
                }
                else{
                    return buyKeys.map((key) => this.buySummary[key].net_amount_sum)
                }
            }
            if(this.config.buy_value_in_base_currency_gross){
                if(this.config.include_correction == "1"){
                    return buyKeys.map((key) => this.buySummary[key].gross_amount_corrected_sum)
                }
                else{
                    return buyKeys.map((key) => this.buySummary[key].gross_amount_sum)
                }
            }
            if(this.config.buy_value_in_base_currency_net_and_vat){
                if(this.config.include_correction == "1"){
                    return buyKeys.map((key) => this.buySummary[key].cost_amount_corrected_sum)
                }
                else{
                    return buyKeys.map((key) => this.buySummary[key].cost_amount_sum)
                }
            }
        }
    }
};
</script>


<style scoped>
</style>
